import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const moment = require('moment');

@Component({
  selector: 'detalles',
  templateUrl: './detalles.component.html',
  styleUrls: ['./detalles.component.scss']
})
export class DetallesComponent implements OnInit {

  @Input() productoElegido: Observable<any>;
  @Input() infoDetalleProducto: Observable<any>;

  @Output() cierraMenu: EventEmitter<any> = new EventEmitter();
  @Output() fijaPanel: EventEmitter<any> = new EventEmitter();

  fechasProducto = [
    { fecha: new Date('1/1/16'), tipo: 'Fecha de lanzamiento' },
    { fecha: new Date('1/1/21'), tipo: 'Fecha de cierre' },
  ];
  datosDetallesProducto: any = {
    producto: 0,
    anio: 2000,
    fechasProducto: [
      { fecha: new Date('1/1/16'), tipo: 'lanzamiento', activa: true },
      { fecha: new Date('1/1/21'), tipo: 'cierre', activa: true },
      { fecha: new Date('1/1/21'), tipo: 'prorroga', activa: false },
    ],
    fechasProrrogas: {
      activas: false,
      ultima: new Date(),
      valorDatePicker: new Date()
    },
    progreso: {
      actual: 0,
      total: 0,
      porcentaje: 0
    },
    diasRestantes: 0,
    urlEncuesta: ''
  };
  diasTotales: number;
  porcentajeDias: number;
  mostrarRecord:boolean=false;
  mostrarAvi:boolean=false;

  constructor() { }

  ngOnInit() {
    this.infoDetalleProducto.subscribe((datos:any) => {
      // console.log("entroDetalles:",datos);
      if (datos != null) {
        // console.log("entroDetalles:",datos);
        this.datosDetallesProducto = datos;
        if (this.datosDetallesProducto.recordatorios) {
          if (this.datosDetallesProducto.recordatorios.length>0) {
            this.mostrarRecord=true;
          }else{
            this.mostrarRecord=false;
          }

        }

        if (this.datosDetallesProducto.avisos) {
          if (this.datosDetallesProducto.avisos.length>0) {
            this.mostrarAvi=true;
          }else{
            this.mostrarAvi=false;
          }

        }
        this.progressBarDias();
      }
    });
  }

  progressBarDias(){
    let refDetalle = this.datosDetallesProducto;
    let inicial = moment(refDetalle.fechasProducto[0].fecha, "YYYY-MM-DD");
    let final = refDetalle.fechasProducto[2].activa == true ? moment(refDetalle.fechasProducto[2].fecha, "YYYY-MM-DD") : moment(refDetalle.fechasProducto[1].fecha, "YYYY-MM-DD");
    this.diasTotales = final.diff(inicial,'days');
    let diffDias: number;
    if(moment().isAfter(final)){
      diffDias = 0;
    } else{
      diffDias = final.diff(moment(),'days');
    }
    this.porcentajeDias = (100 / this.diasTotales) * diffDias;
  }

  cerrar(){
    this.cierraMenu.emit(true);
  }
  fijar(){
    this.fijaPanel.emit(true);
  }

}
